<template>
    <div v-if="records && records.length" class="flex inline bg-default corner">
        <template v-for="item in records" :key="item.name">
            <div class="vertical corner flex">
                <div class="f5 text-center lh-small">{{ item.name }}</div>
                <p v-if="item.value>=0" class="chart-pie small disabled" :class="item.levelClass"><span class="chart-value" :data-value="item.value"></span><b class="chart-text">{{ item.value }}</b></p>
            </div>
        </template>
    </div>
</template>

<script src="./property-poirecord.js"></script>
